import { type SortOrder, type SorterResult } from 'antd/es/table/interface'

import {
  type GetStatisticsTracksQueryFinishedSuccessResultTracksItem,
  type GetStatisticsTracksQueryStart,
} from '../../api'

export type GetTrackStatisticsQuerySortBy =
  GetStatisticsTracksQueryStart['params']['SortBy']

type GetTrackStatisticsSortableKeys = keyof Omit<
  GetStatisticsTracksQueryFinishedSuccessResultTracksItem,
  'id' | 'authors' | 'type'
>

const ORDER_AMOUNT = 2

/**
 * Массив в фиксированном порядке — порядок важен!
 * Индекс = sortBy / 2
 */
const sortableFields = [
  'name',
  'listensCount',
  'listensCount50',
  'listensCount75',
  'listensCount95',
  'sharesCount',
  'searchesCount',
  'swapsCount',
  'likesCount',
  'dislikesCount',
  'playlistsCount',
] as const satisfies readonly GetTrackStatisticsSortableKeys[]

type SortableField = (typeof sortableFields)[number]

export const parseTracksStatisticsSortByToSorterResult = (
  sortBy: GetTrackStatisticsQuerySortBy,
): SorterResult<GetStatisticsTracksQueryFinishedSuccessResultTracksItem> | null => {
  if (!sortBy && typeof sortBy !== 'number') return null
  const fieldIndex = Math.floor(sortBy / ORDER_AMOUNT)
  const field = sortableFields[fieldIndex]
  const order: SortOrder = sortBy % ORDER_AMOUNT === 0 ? 'ascend' : 'descend'
  return { field, order }
}

export const parseTracksStatisticsSorterResultToSortBy = (
  sorterResult: SorterResult<GetStatisticsTracksQueryFinishedSuccessResultTracksItem>,
): GetTrackStatisticsQuerySortBy => {
  if (!sorterResult || !sorterResult.field || !sorterResult.order) return
  const fieldIndex = sortableFields.indexOf(sorterResult.field as SortableField)
  return (fieldIndex * ORDER_AMOUNT +
    (sorterResult.order === 'descend' ? 1 : 0)) as GetTrackStatisticsQuerySortBy
}

export const getTracksStatisticsSortOrderByField = (
  sorterResult: SorterResult<GetStatisticsTracksQueryFinishedSuccessResultTracksItem> | null,
  field: SortableField,
): SortOrder =>
  sorterResult && sorterResult.field === field && sorterResult.order
    ? sorterResult.order
    : null
